import React from 'react'
import Configurator from '../../configurator'
import {
    AVAILABLE_LANGUAGES,
} from '../../consts'

import {
    Route,
    Switch,
} from 'react-router-dom'
import ConnectedRoutes from './ConnectedRoutes'
import { setLanguage } from '../../locales/language-setter'

/**
 * LangRouter class for language switching
 */
class LangRouter extends Configurator {
    /**
     * Gets called on component mounting
     */
    componentDidMount() {
        setLanguage()
    }

    /**
     * Renders base component
     */
    render() {
        return (
            <Switch>
                {AVAILABLE_LANGUAGES.map(language => (
                    <Route key={language} path={`/${language}/*`} exact render={() => <ConnectedRoutes locale={`/${language}`} />}/>
                ))}
            </Switch>
        )
    }
}

export default LangRouter
